module.exports = __webpack_public_path__ + "static/media/new-appt.b2a6ed53.svg";